<template>
  <b-modal
    modal-class="client-form-modal"
    v-model="editorShown"
    size="md-lg"
    centered
    scrollable
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
    footer-class="bg-extra-light-gray"
  >
    <template v-slot:modal-header>
      <div
        class="w-100 d-flex flex-row justify-content-between align-items-center"
      >
        <h5 class="modal-title">
          {{ modalTitle }}
        </h5>
        <div class="d-flex align-items-center">
          <button
            type="button"
            aria-label="Close"
            class="close text-white"
            @click="close"
          >
            ×
          </button>
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div>
          <span class="text-danger"
            ><small>
              Carefully review all documents before applying changes!</small
            >
          </span>
        </div>
        <div style="font-size: 20px">
          <i
            @click="addDocumentZoomArea()"
            class="fa fa-search-plus zoom-control hover-text-primary"
          ></i>
          <i
            @click="lessDocumentZoomArea()"
            class="fa fa-search-minus zoom-control hover-text-primary"
          ></i>
        </div>
        <div>
          <b-button @click="close" variant="secondary" class="mr-2">
            Close
          </b-button>
          <b-button @click="signAll" variant="success">
            {{ mode === "complete" ? "Complete all" : "Sign all" }}
          </b-button>
        </div>
      </div>
    </template>
    <div class="h-100 w-100 text-center preview-modal">
      <zoom-area
        width="1125px"
        ref="documentZoomArea"
        :hide-controls="true"
        class="h-100"
      >
        <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :pdf-quality="2"
          :pdf-content-width="'100%'"
          :paginate-elements-by-height="1500"
          class="w-100"
        >
          <template slot="pdf-content">
            <div v-if="html" v-html-sanitize="html" class="m-4" />
          </template>
        </vue-html2pdf>
      </zoom-area>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import documentServer from "../../server/document";
import ZoomArea from "../controls/ZoomArea";
import VueHtml2pdf from "vue-html2pdf";

export default {
  name: "ReviewDocumentsModal",
  components: { ZoomArea, VueHtml2pdf },
  props: ["docs", "mode"],
  data() {
    return {
      html: null
    };
  },
  mounted() {
    const url = documentServer.renderDocuments();
    fetch(url.url, {
      method: "POST",
      headers: url.headers,
      body: JSON.stringify(this.docs)
    }).then(response => {
      var clone = response.clone();

      response.blob().then(blob => {
        this.blobUrl = URL.createObjectURL(blob);
      });

      clone.text().then(html => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        this.html = doc.body.innerHTML
          .replace(/vh-100/gi, "")
          .replace(
            /document-single"/gi,
            `document-single" style="margin-bottom: 32px;"`
          );
      });
    });
  },
  methods: {
    ...mapActions("layout", ["show", "hide"]),
    signAll() {
      return this.mode === "complete"
        ? this.$emit("completeAll")
        : this.$emit("signAll");
    },
    close() {
      this.editorShown = false;
      this.$emit("close");
    },
    addDocumentZoomArea() {
      this.$refs.documentZoomArea.addZoom();
    },
    lessDocumentZoomArea() {
      this.$refs.documentZoomArea.lessZoom();
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    modalTitle() {
      return "Review Documents";
    }
  }
};
</script>

<style scoped>
.preview-modal {
  min-height: calc(85vh - 120px);
}
.zoom-control {
  width: 37px;
}
.zoom-control:hover {
  font-size: 21px;
  cursor: pointer;
}
</style>
